import { useState, useRef, useEffect } from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { UPDATE_DRAWBOOKENTRYSWAP } from '../../../../config/api';
import axios from 'axios'
import './Draganddropswap.css';
import { Checkdevice } from '../../../../components';

// Styles for the list container
const getListStyle = isDraggingOver => ({
    background: 'var(--subgrey)',
    padding: '2px 0px'
    // padding: 8,
});

// Styles for each draggable item
const getMainobjStyle = (isDragging, draggableStyle) => ({
    userSelect: 'none',
    // margin: 5,
    // background: isDragging ? '#a0a0a0' : '#ffffff',
    borderTop: isDragging ? '2px solid var(--subgrey)' : '2px solid var(--subgrey)',
    borderBottom: isDragging ? '2px solid var(--subgrey)' : '2px solid var(--subgrey)',
    borderLeft: isDragging ? '2px solid var(--subgrey)' : 0,
    borderRight: isDragging ? '2px solid var(--subgrey)' : 0,
    margin: '0px 4px',
    ...draggableStyle,
});

function Draganddropswap(props) {
    const { entryid, guestdata, guestdataaddr = [], setGuestdataaddr, _id, urlhandler, token, setSavetxt, backupguestdataaddr, setBackupguestdataaddr } = props;
    const [firsttime, setFirsttime] = useState(true)

    const [toggleswapsave, setToggleswapsave] = useState(false)

    const device = Checkdevice()

    useEffect(() => {
        if (firsttime) {
            setBackupguestdataaddr(guestdataaddr.slice())
            setFirsttime(false)
        }
    }, [guestdataaddr, guestdata, firsttime])

    // Handle drag end
    const onDragEnd = (result) => {
        const { source, destination } = result;

        if (!destination) return;

        // No change in position → do nothing
        if (source.index === destination.index) return;

        const newOrder = Array.from(guestdataaddr);

        const [moved] = newOrder.splice(source.index, 1);
        newOrder.splice(destination.index, 0, moved);

        setGuestdataaddr && setGuestdataaddr(newOrder);

        // 🔥 Trigger toggle save only when swap is successful
        setToggleswapsave(true);
    };

    const cancel = () => {
        setGuestdataaddr(backupguestdataaddr.slice())
        setToggleswapsave(false)
    }

    const save = () => {
        axios({
            method: 'POST',
            url: UPDATE_DRAWBOOKENTRYSWAP,
            headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }, //need token from the web
            data: { _id, urlhandler, guestdataaddr }
        })
            .then((item) => {

                const { message } = item.data
                if (message === 'SUCCESS') {
                    setSavetxt('Saved!')

                    setTimeout(() => {
                        setSavetxt('')

                    }, 1000)
                }
            })
            .catch((e) => { })
    }

    return (
        <div className='Draganddropswap_root'>
            <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId={'main'} type="main">
                    {(provided, snapshot) => (
                        <div
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                            style={getListStyle(snapshot.isDraggingOver)}
                        >
                            {guestdataaddr.map((key, index) => {
                                const { name, image, msg } = guestdata[key] || {};
                                console.log(key, entryid)
                                return (
                                    <Draggable
                                        key={key}
                                        draggableId={key.toString()}
                                        index={index}
                                        type="main"
                                    >
                                        {(provided, snapshot) => (
                                            <div
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                                style={getMainobjStyle(
                                                    snapshot.isDragging,
                                                    provided.draggableProps.style
                                                )}
                                            >
                                                <div className='Draganddropswap_maindrag' style={{ backgroundColor: entryid === key ? 'var(--hoverpink)' : '#ffffff' }}>
                                                    <img className='Draganddropswap_imgroot' src={image} />
                                                    <div className='Draganddropswap_col'>
                                                        <div className='Draganddropswap_nameroot'>{name}</div>
                                                        <div className='Draganddropswap_msgroot' >{msg}</div>
                                                    </div>

                                                </div>
                                            </div>
                                        )}
                                    </Draggable>
                                );
                            })}
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            </DragDropContext>
            {toggleswapsave
                // ? <div className={'Draganddropswap_rowroot'+`_${device}`}>
                ? <div className={'Draganddropswap_rowroot'}>
                    <button className='Draganddropswap_cancel' onClick={cancel}>Cancel</button>
                    <button className='Draganddropswap_save' onClick={save}>Save</button>
                </div>
                : null}
        </div>
    );
}

export default Draganddropswap;